export const SET_BTN_DISABLED = 'SET_BTN_DISABLED'
export const SET_SELECTED_TASK = 'SET_SELECTED_TASK'
export const SET_SELECTED_TASK_ONLY = 'SET_SELECTED_TASK_ONLY'
export const SET_CURRENT_INDEX = 'SET_CURRENT_INDEX'
export const RESET_TASK_DATA = 'RESET_TASK_DATA'
export const UPDATE_RECEIVE_PHONE = 'UPDATE_RECEIVE_PHONE'
export const UPDATE_AVAILABLE_PHONE = 'UPDATE_AVAILABLE_PHONE'
export const UPDATE_GOOGLE_ADMIN_EMAIL = 'UPDATE_GOOGLE_ADMIN_EMAIL'
export const SET_USE_EXTENSION = 'SET_USE_EXTENSION'
